import { tns } from "tiny-slider";

function initHeroSlider(id) {
	tns({
		container: "#" + id,
		mode: "carousel",
		items: 1,
		loop: true,
		autoplay: true,
		autoplayTimeout: 3500,
		speed: 800,
		nav: true,
		navPosition: "bottom",
		controls: false,
		autoplayButtonOutput: false,
		onInit: function () {
			const el = document.getElementById(id);
			const wrapper = el && el.closest(".hero-slider-loading");
			if (wrapper) wrapper.classList.remove("hero-slider-loading");
		},
	});
}

window.initHeroSlider = initHeroSlider;
